import styled, { css } from 'styled-components/macro';
import { IInputState } from '../../types';
import { FormStateColors } from '../../constants';

export const MessageContainer = styled.div<{ $state: IInputState }>`
  ${({ theme, $state }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xs};
    color: ${FormStateColors(theme)[$state].text};
  `}
`;
